import React from 'react'
import { connect } from 'react-redux'
import { Router, Switch, Route, useRouteMatch } from 'react-router-dom'
import LoginContainer from './LoginContainer'
import SectionContainer from './MapKeysContainer'
import AddSectorContainer from './AddSectorContainer'
import AddUserContainer from './AddUserContainer'
import AddCompanyContainer from './AddCompanyContainer'
import AddIndustryContainer from './AddIndustryContainer'
import SettingsContainer from './SettingsContainer'
import DashboardContainer from './DashboardContainer'
import ManageCompanyContainer from './ManageCompanyContainer'
import ManageIndustryContainer from './ManageIndustryContainer'
import ManageContentContainer from './ManageContentContainer'
import ManageUserContainer from './ManageUserContainer'
import CompanyListContainer from './CompanyListContainer'
import ViewCompanyContainer from './ViewCompanyContainer'
import ManageSectorContainer from './ManageSectorContainer'
import ViewIndustryContainer from './ViewIndustryContainer'
import AddExchangeContainer from './AddExchangeContainer'
import ManageExchangeContainer from './ManageExchangeContainer'
import MapKeysContainer from './MapKeysContainer'
import BulkUploadContainer from './BulkUploadContainer'
import LibraryContainer from './LibraryContainer'
import PreviewContainer from './PreviewContainer'
import HeaderContainer from './HeaderContainer'
import SidebarContainer from './SidebarContainer'
import { createBrowserHistory } from 'history'
import BulkCopyContainer from './BulkCopyContainer'
import MedievalMapComponent from '../components/MedievalMapComponent'

export const appHistory = createBrowserHistory()
function DashboardContainerFrozen() {
  const { path } = useRouteMatch()
  return (
    <div className="dashboard">
      <HeaderContainer />
      <Router history={appHistory}>
        <div className="dashboardContainer">
          <SidebarContainer />
          <div className="dashboard--wrapper dataTable">
            <Switch>
              <Route path={`${path}/section`}>
                <SectionContainer />
              </Route>
              <Route path={`${path}/add-user`}>
                <AddUserContainer />
              </Route>
              <Route path={`${path}/add-sector`}>
                <AddSectorContainer />
              </Route>
              <Route exact path={`${path}/add-sector/:id`}>
                <AddSectorContainer />
              </Route>
              <Route exact path={`${path}/add-company`}>
                <AddCompanyContainer />
              </Route>
              <Route exact path={`${path}/edit-company/:id`}>
                <AddCompanyContainer />
              </Route>
              <Route exact path={`${path}/add-company/:industryId?/:sectorId?`}>
                <AddCompanyContainer />
              </Route>
              <Route exact path={`${path}/edit-company/:id`}>
                <AddCompanyContainer />
              </Route>
              <Route exact path={`${path}/add-industry/:sectorId?`}>
                <AddIndustryContainer />
              </Route>
              <Route exact path={`${path}/settings`}>
                <SettingsContainer />
              </Route>
              <Route exact path={`${path}/login`}>
                <LoginContainer />
              </Route>
              <Route exact path={`${path}/company-list/:type?/:typeId?`}>
                <ManageCompanyContainer />
              </Route>
              <Route path={`${path}/company-tree`}>
                <CompanyListContainer />
              </Route>
              <Route exact path={`${path}/industry-list/:sectorId?`}>
                <ManageIndustryContainer />
              </Route>
              <Route exact path={`${path}/content-list`}>
                <ManageContentContainer />
              </Route>
              <Route exact path={`${path}/user-list`}>
                <ManageUserContainer />
              </Route>
              <Route exact path={`${path}/view-company/:id?`}>
                <ViewCompanyContainer />
              </Route>
              <Route exact path={`${path}/view-industry`}>
                <ViewIndustryContainer />
              </Route>
              <Route exact path={`${path}/sector-list`}>
                <ManageSectorContainer />
              </Route>
              <Route exact path={`${path}/edit-sector/:id`}>
                <AddSectorContainer />
              </Route>
              <Route exact path={`${path}/edit-user/:id`}>
                <AddUserContainer />
              </Route>
              <Route exact path={`${path}/add-exchange`}>
                <AddExchangeContainer />
              </Route>
              <Route exact path={`${path}/exchange-list`}>
                <ManageExchangeContainer />
              </Route>
              <Route exact path={`${path}/import-data`}>
                <BulkCopyContainer />
              </Route>
              <Route exact path={`${path}/edit-industry/:id`}>
                <AddIndustryContainer />
              </Route>
              <Route exact path={`${path}/bulk-upload`}>
                <BulkUploadContainer />
              </Route>
              <Route exact path={`${path}/map-keys`}>
                <MapKeysContainer />
              </Route>
              <Route exact path={`${path}/library`}>
                <LibraryContainer />
              </Route>
              <Route exact path={`${path}/edit-exchange/:id`}>
                <AddExchangeContainer />
              </Route>
              <Route exact path={`${path}/preview`}>
                <PreviewContainer isReload={true} />
              </Route>
              <Route exact path={`${path}/medieval-map-demo`}>
                <MedievalMapComponent />
              </Route>
              {/*<Route path={`${path}/bulk-copy`}>
                <BulkCopyContainer/>
              </Route>
            */}
              <Route path="*">
                <DashboardContainer className="DashboardSec" />
              </Route>
            </Switch>
          </div>
        </div>
      </Router>
    </div>
  )
}

const mapStateToProps = state => {
  return { auth: state.user ? state.user : null }
}
export default connect(mapStateToProps)(DashboardContainerFrozen)


